import { BaseDropdownItem } from '../../components/ui-kits/hcl-sdk-combobox/types';
import StoreProvider from './StoreProvider';

export type ComboboxParams = {
  isOpen: boolean;
  innerInputValue: string;
  innerValue: BaseDropdownItem | null;
  optionSelected: number;
  optionFocusIndex: number;
  isFocus: boolean;
};

export const DefaultComboboxParams: ComboboxParams = {
  isOpen: false,
  innerInputValue: '',
  innerValue: null,
  optionSelected: -1,
  optionFocusIndex: -1,
  isFocus: false,
};

export type HclSDKComboboxData = Record<string, ComboboxParams>;

export const initStateComboBoxStore: HclSDKComboboxData = {};

class ComboboxStore extends StoreProvider<HclSDKComboboxData> {
  constructor(state: HclSDKComboboxData) {
    super(state);
    this.state = state;
  }

  setFieldState(fieldName: string, newState: Partial<ComboboxParams>) {
    if (this.state[fieldName]) {
      this.state[fieldName] = {
        ...this.state[fieldName],
        ...newState,
      };
    } else {
      this.state[fieldName] = {
        ...DefaultComboboxParams,
        ...newState,
      };
    }
  }

  getIsOpen(fieldName: string) {
    return this.state[fieldName]?.isOpen;
  }
  getInnerInputValue(fieldName: string) {
    return this.state[fieldName]?.innerInputValue;
  }
  getInnerValue(fieldName: string) {
    return this.state[fieldName]?.innerValue;
  }
  getOptionSelected(fieldName: string) {
    return this.state[fieldName]?.optionSelected;
  }
  getOptionFocusIndex(fieldName: string) {
    return this.state[fieldName]?.optionFocusIndex;
  }
  getIsFocus(fieldName: string) {
    return this.state[fieldName]?.isFocus;
  }
}

export default ComboboxStore;
